import React from "react";
import { sections } from "../../data/data";
import { useTranslation } from "react-i18next";
import SubMenu from "./SubMenu";
import { Collapse } from "antd";
import { useNavigate } from "react-router-dom";
interface BurgerTabsProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
}
const BurgerNavigationMenu = ({ ...props }: BurgerTabsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <nav
      {...props}
      className={`takaful--burger-menu-content ${props.className ?? ""}`}
    >
      <Collapse
        className="takaful--collapse-recipient takaful--collapse-burger"
        accordion
      >
        {sections.map((section) => (
          <Collapse.Panel
            key={section.id}
            header={
              <div className="takaful--header-recipient-container">
                <div className="takaful--header-recipient-collapse">
                  {section.link && !section.subList?.length ? (
                    <span
                      className="takaful--list-item"
                      onClick={() => navigate(section.link)}
                    >
                      {t(section.label)}
                    </span>
                  ) : (
                    <span className="takaful--list-item">
                      {t(section.label)}
                    </span>
                  )}
                </div>
              </div>
            }
            className="takaful--header-recipient-Panel takaful--collapse-burger-panel "
          >
            {section?.subList && section?.subList?.length > 0 && (
              <>
                <SubMenu
                  className="takaful--sub-menu-burger"
                  items={section.subList}
                />
              </>
            )}
          </Collapse.Panel>
        ))}
      </Collapse>
    </nav>
  );
};

export default BurgerNavigationMenu;
